export const getBrandHistory = ({
  locale,
  slug,
}: {
  locale: string;
  slug: string;
}) => {
  try {
    const history = require(`../static/brand-history/${slug}-vb/${locale}.md`);

    return {
      attributes: history.attributes,
      html: history.html,
    };
  } catch (e) {
    return null;
  }
};
